import React from "react";
import "./precisionClicker.css";
import { Link, useNavigate } from "react-router-dom";
import HeaderLink from "../common/headerLink";
import RainbowButton from "../common/rainbowButton";
import { loadHighScore } from "./storage/gameStorage";
import { numberWithCommas } from "../utils/numberFormatter";
import { screens } from "../utils/links";

export default function PrecisionClickerHighScore() {
  const highScore = loadHighScore();
  const navigate = useNavigate();

  return (
    <div>
      <HeaderLink />
      <section className="instructions">
        <h2>
          High Score — <span className="rainbow-text">Precision Clicker</span>
        </h2>

        {highScore > 0 ? (
          <div className="high-score-display">
            <div className="high-score-display__trophy" aria-hidden="true">🏆</div>
            <div className="high-score-display__score">{numberWithCommas(highScore)}</div>
          </div>
        ) : (
          <p className="high-score-display__empty">No score yet. Go play!</p>
        )}

        <div className="cta-container">
          <Link className="cta" to={screens.precisionClicker.play}>
            <RainbowButton>Play Now</RainbowButton>
          </Link>
          <button
            className="no-button fake-link cta"
            onClick={() => navigate(-1)}
          >
            Go Back
          </button>
        </div>
      </section>
    </div>
  );
}
